import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastTextField } from 'src/components/mui-overrides/Textfield';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { POST_WITH_ID } from '@brickwise/asset-validation/dist/asset/assetData';
import { NormalDatepicker } from 'src/components/mui-overrides/Datepicker';
import { DefaultFastSelectField } from 'src/components/mui-overrides/SelectTextField';
import { AssetTypeConditional } from '../../user/AssetTypeConditional';

interface Props {
  disabled: boolean;
}

export const PowerplantOverview: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const formik = useFormikContext<POST_WITH_ID>();

  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.main.powerplantoverview.title')}>
      <DefaultFastTextField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.powerplantoverview.fields.powerOutput.label')}
        fieldName="propertyDetails.powerOutput"
        type="number"
      />
      <DefaultFastTextField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.powerplantoverview.fields.powerOutputPerAnno.label')}
        fieldName="propertyDetails.powerOutputPerAnno"
        type="number"
      />
      <DefaultFastSelectField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.powerplantoverview.fields.powerPlantType.label')}
        fieldName="propertyDetails.constructionType"
        options={[
          { value: 'roof', label: t('general.propertyDetails.powerplantConstructionType.roof.label') },
          { value: 'landsite', label: t('general.propertyDetails.powerplantConstructionType.landsite.label') },
          { value: 'integrated', label: t('general.propertyDetails.powerplantConstructionType.integrated.label') },
        ]}
      />
      <AssetTypeConditional supported="powerplant">
        <NormalDatepicker
          disabled={disabled}
          label={t('dashboard.assets.addedit.main.powerplantoverview.fields.commissioningDate.label')}
          fieldName="propertyDetails.commissioningDate"
          formik={formik}
        />
      </AssetTypeConditional>
      <DefaultFastTextField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.powerplantoverview.fields.lifespan.label')}
        fieldName="propertyDetails.lifespan"
        type="number"
      />
      <DefaultFastTextField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.powerplantoverview.fields.propertySecurity.label')}
        fieldName="propertyDetails.propertySecurity"
        type="text"
      />
      <DefaultFastTextField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.powerplantoverview.fields.storage.label')}
        fieldName="propertyDetails.storage"
        type="text"
      />
      <DefaultFastTextField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.powerplantoverview.fields.storageSize.label')}
        fieldName="propertyDetails.storageSize"
        type="text"
      />
    </LaunchpadCard>
  );
};
